/* globals lp, jui, Class */
var _ = require('lodash');
var jQuery = require('jquery');
var React = require('react');
var ReactDOM = require('react-dom');

var banzai = require('ub/control/banzai-features');

var LightboxSizeControl = require('ub/ui/lightbox-size-control');
var PhoneNumberActionField = require('ub/ui/properties-panel/phone-number-action-field');
var EmailActionFields = require('ub/ui/properties-panel/email-action-fields');
var getPreviewWarning = require('ub/ui/labels/preview-warning').default;
var ResolutionPanel = require('ub/ui/properties-panel/images/resolution-panel').default;
var ImageCompressionPanel = require('ub/ui/properties-panel/images/compression-panel').default;
var ColorControls = require('ub/ui/svg/color-controls').default;
var getMaxResolutionAvailable = require('ub/control/image-publish-urls').getMaxResolutionAvailable;

var planFeatures = require('ub/plan-features.js').default;

module.exports = Class.create(
  lp.editor.panel.ElementPropertiesPanel,
  lp.editor.panel.ElementGeometryControls,
  lp.editor.panel.ElementBorderControls,
  lp.ModuleComponent,
  {
    type:'lp-pom-image',

    initialize: function($super) {
      $super();
    },

    installUI: function($super) {
      $super();
      var self = this;

      var geometryPanel = this.insert(new jui.CollapsiblePanel({
        title     : 'Geometry',
        attributes: {
          className: 'collapsible-panel panel-image-geometry'
        }
      }));

      var generalPanel  = this.insert(new jui.CollapsiblePanel({
        title     : 'Image Properties',
        attributes: {
          className: 'collapsible-panel panel-image-properties'
        }
      }));

      if (planFeatures.isFeatureEnabled('retinaImages')) {
        this.resolutionPanelContainer = this.insert(document.createElement('div'));
      }

      if(banzai.features.isImageCompressionEnabled()) {
        this.imageCompressionContainer = this.insert(document.createElement('div'));
      }

      var actionPanel = this.insert(new jui.CollapsiblePanel({
        title     : 'Click Action',
        attributes: {
          className: 'collapsible-panel panel-image-action'
        }
      }));

      var borderPanel = this.insert(new jui.CollapsiblePanel({
        title     : 'Border Properties',
        attributes: {
          className: 'collapsible-panel panel-image-border labels-above'
        }
      }));

      this._uiBinding.subscribeDomainEvents(this.domainEvents, this);

      this.installGeometryControls({
        insert      : geometryPanel.insertContent.bind(geometryPanel),
        sizeOptions : {
          showMaintainAR: true
        }
      });

      this._geometryControlUIEventHandlers = _.merge(
        {},
        this._geometryControlUIEventHandlers, {
          changeSize: function(ev, model, um) {
            var newSize = _.clone(ev.size);
            if (window.editor.imageTransformBox.mode === 'scale') {
              var startImageSize = Object.clone(model.get('geometry.transform.size'));
              var startSize = model.getSize();
              var xScale = newSize.width / startSize.width;
              var yScale = newSize.height / startSize.height;
              model.setImageSize({
                width:Math.round(startImageSize.width * xScale),
                height:Math.round(startImageSize.height * yScale)
              }, um);
            }
            model.setMaskSize(newSize, um);
            self.element.updateImageSize();
            self._syncResolutionPanel();
          }
        });

      this.installBorderControls({insert:borderPanel.insertContent.bind(borderPanel)});

      var requestFocus = this.requestFocus.bind(this);

      this.controls.changeImageButton = generalPanel.insertContent(new jui.FormAssetChooser({
        label        : 'Image',
        noFileText   : 'No image specified',
        changeAction : function() {
          self._uiBinding.onNext({
            type : 'selectImage'
          });
        }
      }));

      if (banzai.features.isSvgColorEnabled()) {
        var svgColorContainerDiv = document.createElement('div');
        this.controls.svgColorFields = generalPanel.insertContent(svgColorContainerDiv);
      }

      this.controls.altField = generalPanel.insertContent(new jui.FormTextArea({
        label  : 'Alt Text',
        onblur : function(e) {
          self._uiBinding.onNext({
            type    : 'changeAltText',
            altText : e.source.getValue()
          });
        },
        onfocus: requestFocus
      }));

      this.controls.titleField = generalPanel.insertContent(new jui.FormTextInput({
        label  : 'Title',
        onblur : function(e) {
          self._uiBinding.onNext({
            type  : 'changeTitle',
            title : e.source.getValue()
          });
        },
        onfocus: requestFocus
      }));

      this.controls.action = actionPanel.insertContent(new jui.FormSelect({
        label             : 'Action',
        id                : 'jui-button-action-select',
        dropDownClassName : 'editor-info-panel-select jui-drop-down action-dropdown',
        selectOptions     : this._buildActionOptions(),
        action: function(e) {
          self._uiBinding.onNext({
            type   : 'changeAction',
            action : e.source.getValue(),
          });
        }
      }));

      this.controls.linkField = actionPanel.insertContent(new jui.FormLinkInput2({
        label        : 'URL',
        passparams   : true,
        onPassParams : function(e) {
          self._uiBinding.onNext({
            type       : 'changePassParams',
            passParams : e.source.getValue()
          });
        },
        onblur     : function(e) {
          self._uiBinding.onNext({
            type : 'changeLink',
            link : e.source.getValue()
          });
        },

        onfocus: requestFocus
      }));

      this.controls.phoneNumberField = new PhoneNumberActionField({
        container: actionPanel.content.e,
        uiBinding: self._uiBinding,
      });

      this.controls.email = new EmailActionFields({
        container: actionPanel.content.e,
        uiBinding: self._uiBinding
      });

      this.controls.externalLightboxSize = actionPanel.insertContent(new LightboxSizeControl({
        onblur: function(e) {
          self._uiBinding.onNext({
            type: 'changeExternalLightboxSize',
            size: e.source.getValue()
          });
        },
        onfocus: self.requestFocus.bind(self)
      }).hide());

      this.controls.previewWarning = actionPanel.insertContent(getPreviewWarning());
    },

    activate: function($super) {
      $super();

      if (banzai.features.isSvgColorEnabled()) {
        var elm = this.element;
        var model = elm.model;
        var imageColors = model.safeGet('svgColors');

        this.renderSVGControls(imageColors);
      }
    },

    restoreSizeClicked: function(selected) {
      /* jshint unused:vars */
      this.element.removeTransformations();
      window.editor.imageTransformBox.setMode('scale');
    },

    renderSVGControls: function(colorGroups) {
      var reactElement = React.createElement(ColorControls, { colorGroups: colorGroups });
      ReactDOM.render(reactElement, this.controls.svgColorFields);
    },

    setElement: function($super, elm) {
      var model = elm.model;

      this.modelChangeHandlers.push( function(event) {
        this._updatePanelStates(model, event);
      }.bind(this));

      $super(elm);
    },

    _updatePanelStates: function(model, event) {
      /* jshint maxcomplexity:15 */
      var accessor = event.data.accessor;
      var dataValue = event.data.value || '';

      if (accessor.startsWith('geometry')) {
        this._syncResolutionPanel();
      }

      switch (accessor) {
        case 'geometry.aspectRatio':
          var size = model.getSize();
          this.controls.size.setAspectRatio(size.width / size.height);
          break;
        case 'geometry.maintainAR':
          this.controls.size.setMaintainAspectRatio(event.data.value);
          break;
        case 'geometry.transform.quality':
          this._syncCompressionPanel();
          break;
        case 'content.asset':
          this._syncCompressionPanel();
          break;
        case 'content.alt':
          this.controls.altField.setValue(dataValue);
          break;
        case 'content.title':
          this.controls.titleField.setValue(dataValue);
          break;
        case 'content.link':
          this._syncLinkField(model);
          break;
        case 'content.target':
          this._syncLinkField(model);
          break;
        case 'action.emailAddress':
          this.controls.email.setEmailAddress(dataValue);
          break;
        case 'action.emailSubject':
          this.controls.email.setEmailSubjectField(dataValue);
          break;
        case 'action.phoneNumber':
          this.controls.phoneNumberField.setValue(dataValue);
          break;
        case 'svgColors':
          this.renderSVGControls(dataValue);
      }
    },

    _syncLinkField: function(model) {
      this.controls.externalLightboxSize.setValue(
        model.safeGet('lightboxSize') || lp.module.image.ImageElement.lightboxSizeDefault
      );

      this.controls.linkField.setValue({
        url: model.safeGet('content.link') || '',
        target: model.safeGet('content.target') || '',
        passparams: model.safeGet('content.passparams') || false
      });
    },

    _syncEmailAndPhoneUIControls: function(elm) {
      this.controls.email.setValue({
        emailAddress: elm.model.safeGet('action.emailAddress') || '',
        emailSubject: elm.model.safeGet('action.emailSubject') || '',
      });

      this.controls.phoneNumberField.setValue(elm.model.safeGet('action.phoneNumber') || '');
    },

    syncUIControls: function($super, elm) {
      $super(elm);

      var m = elm.model;

      this.bindGeometryControlsToElement(elm);
      this.bindBorderControlsToElement(elm);

      if (m.exists('content.asset.size')) {
        var assetSize = m.get('content.asset.size');
        this.controls.size.setAspectRatio(assetSize.width / assetSize.height);
      }

      if (elm.model.isSvg()) {
        this.controls.size.maintainAR.e.style.display = 'none';
      } else {
        this.controls.size.maintainAR.e.style.display = 'block';
      }

      this.controls.size.setMaintainAspectRatio(m.safeGet('geometry.maintainAR') || true);

      this._syncLinkField(m);

      this.controls.changeImageButton.setAsset(m.get('content.asset'));
      this.controls.altField.setValue(elm.model.exists('content.alt') ? elm.model.get('content.alt') : '');
      this.controls.titleField.setValue(elm.model.exists('content.title') ? elm.model.get('content.title') : '');

      this.syncActionControls(m.safeGet('action.type') || 'url');
      this._syncEmailAndPhoneUIControls(elm);
      this._syncResolutionPanel();
      this._syncCompressionPanel();
    },

    _syncResolutionPanel: function() {
      if (!planFeatures.isFeatureEnabled('retinaImages')) {
        return;
      }

      var breakpoint = this.element.page.getCurrentBreakpoint();

      ReactDOM.render(
        React.createElement(ResolutionPanel, {
          isSvg: this.element.model.isSvg(),
          maxResolution: getMaxResolutionAvailable(
            this.element.model.safeGet('content.asset.size', breakpoint),
            this.element.model.safeGet('geometry.transform.size', breakpoint)
          ),
          onUploadImage: function() {
            this._uiBinding.onNext({
              type : 'selectImage'
            });
          }.bind(this),
        }),
        this.resolutionPanelContainer
      );
    },

    _syncCompressionPanel: function() {
      if (!banzai.features.isImageCompressionEnabled()) {
        return;
      }

      ReactDOM.render(
        React.createElement(ImageCompressionPanel, {
          mimeType: this.element.model.safeGet('content.asset.content_content_type'),
          value: this.element.model.safeGet('geometry.transform.quality'),
          onChange: function(quality) {
            this._uiBinding.onNext({
              type: 'changeQuality',
              quality: quality,
            });
          }.bind(this)
        }),
        this.imageCompressionContainer
      );
    },

    _buildActionOptions: function() {
      var options = [{
        name: 'Go to URL',
        value: 'url'
      }];

      if (this.element && this.element.page.allowExternalLightboxes()) {
        options.push({
          name: 'Open URL in Lightbox',
          value: 'externalLightbox'
        });
      }

      options.push({
        name: 'Call a number',
        value: 'phone'
      });

      options.push({
        name: 'Send an email',
        value: 'email'
      });

      return options;
    },

    syncActionControls: function(action) {
      var options = this._buildActionOptions();
      var showLinkField = _.include(['url', 'externalLightbox'], action);

      // If there's only one action option left, hide the entire control
      this.controls.action.setVisible(options.length > 1);

      // Show and hide individual controls based on which action is currently selected
      this.controls.linkField.setVisible(showLinkField);
      this.controls.linkField.target.setVisible(action === 'url');
      this.controls.externalLightboxSize.setVisible(action === 'externalLightbox');
      this.controls.email.setVisible(action === 'email');
      this.controls.phoneNumberField.setVisible(action === 'phone');

      this.controls.action.setSelectOptions(options);
      this.controls.action.setSelectedValue(action);

      this.controls.previewWarning[showLinkField ? 'show' : 'hide']();
    },

    _updateActionFieldValue: function(propertyName, actionValue) {
      this.performModelUpdates(function() {
        var um = this.element.page.undoManager;

        um.startGroup();

        if (_.isEmpty(actionValue)) {
          this.element.model.deleteAttr(propertyName, um);
        } else {
          this.element.model.set(propertyName, actionValue, um);
        }

        um.endGroup();

      }.bind(this));
    },

    domainEvents: {
      changeAction: function(ev) {
        var action = ev.action;
        var self = this;

        if(action === "externalLightbox") {
          jQuery(window).trigger('externalLightboxSelected');
        }

        this.syncActionControls(action);
        this.performModelUpdates(function(){
          self.element.model.set('action.type', action, self.element.page.undoManager);
        });
      },

      changeAltText: function(ev) {
        var self = this;

        self.performModelUpdates( function() {
          var alt = ev.altText;
          var um  = self.element.page.undoManager;

          if (alt === '') {
            self.element.model.deleteAttr('content.alt', um);
          } else {
            self.element.model.set('content.alt', alt, um);
          }

          self.controls.altField.setValue(alt); // Sync controls
        });
      },

      changeExternalLightboxSize: function(ev) {
        var self = this;
        this.performModelUpdates(function() {
          self.element.model.set('lightboxSize', ev.size, self.element.page.undoManager);
        });
        this.controls.externalLightboxSize.setValue(ev.size); // Sync control
      },

      changeTitle: function(ev) {
        var self = this,
            title = ev.title,
            um = self.element.page.undoManager;

        self.performModelUpdates( function() {
          if (title === '') {
            self.element.model.deleteAttr('content.title', um);
          } else {
            self.element.model.set('content.title', title, um);
          }
        });

        self.controls.titleField.setValue(title); // Sync controls
      },

      changeLink: function(ev) {
        var self = this,
            link = ev.link,
            um   = self.element.page.undoManager;

        self.performModelUpdates(function() {
          um.startGroup();
          if (link.url === '') {
            self.element.model.deleteAttr('content.link', um);
          } else {

            // fallback default action to url
            var actionType = self.controls.action ? self.controls.action.currentValue : 'url';
            self.element.model.set('action.type', actionType);

            self.element.model.set('content.link', link.url, um);
          }

          if (link.target === '') {
            self.element.model.deleteAttr('content.target', um);
          } else {
            self.element.model.set('content.target', link.target, um);
          }
          um.endGroup();
        });

        self.controls.linkField.setValue(link); // Sync controls
      },

      changePhoneNumber: function(ev) {
        this._updateActionFieldValue('action.phoneNumber', ev.value);
      },

      changeEmailAddress: function(ev) {
        this._updateActionFieldValue('action.emailAddress', ev.value);
      },

      changeEmailSubject: function(ev) {
        this._updateActionFieldValue('action.emailSubject', ev.value);
      },

      changePassParams: function(ev) {
        var self = this;
        this.performModelUpdates(function() {
          self.element.model.set('content.passparams', ev.passParams, self.element.page.undoManager);
        });
      },

      selectImage: function() {
        var self = this;

        this.getModule().openElementBuilder(this.element, {
          callback: function(asset) {
            self._uiBinding.onNext({
              type  : 'changeImage',
              image : asset
            });
          },
          selectedAsset: self.element.model.get('content.asset')
        });
      },

      changeImage: function(ev) {
        if (ev.image.uuid !== this.element.model.get('content.asset.uuid')) {
          this.element.replaceImage(ev.image);
          this.controls.changeImageButton.setAsset(ev.image); // Sync controls
        }
      },

      changeQuality: function(ev) {
        if (ev.quality !== this.element.model.safeGet('geometry.transform.quality')) {
          this.element.set('geometry.transform.quality', ev.quality);
        }
      }
    }

  }
);



//////////////////
// WEBPACK FOOTER
// ./src/legacy/lp/modules/lp-image/image_element_properties_panel.js
// module id = 1451
// module chunks = 0